<template>
  <div>
    <div class="cal-sans-regular black--text font-size-28 pb-2 mt-3" style="border-bottom: 3px solid #4caf50">Reader Preview</div>
    <div class="mt-4">
      <div v-for="(page, index) in pages" :key="'preview-page-' + index" class="mb-6">
        <div class="subtitle-1 mb-2">{{ page.title || ('Page ' + (index + 1)) }}</div>
        <v-img v-if="page.showImage && page.imageUrl" :src="page.imageUrl" contain max-height="240" class="mb-3" />
        <div style="white-space: pre-wrap; line-height: 1.7;">
          {{ page.content || 'No content yet.' }}
        </div>
        <v-divider class="my-6"></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoryPreview',
  props: {
    story: {
      type: Object,
      required: false,
      default: null,
    },
    pages: {
      type: Array,
      required: true,
    }
  },
}
</script>